import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { FuseFullscreenComponent } from '@fuse/components/fullscreen';

import {
    FuseNavigationService,
    FuseVerticalNavigationComponent,
} from '@fuse/components/navigation';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { LanguagesComponent } from 'app/layout/common/languages/languages.component';
import { MessagesComponent } from 'app/layout/common/messages/messages.component';
import { NotificationsComponent } from 'app/layout/common/notifications/notifications.component';
import { QuickChatComponent } from 'app/layout/common/quick-chat/quick-chat.component';
import { SearchComponent } from 'app/layout/common/search/search.component';
import { ShortcutsComponent } from 'app/layout/common/shortcuts/shortcuts.component';
import { UserComponent } from 'app/layout/common/user/user.component';
import { NotificationService } from 'app/services/notification.service';
import { GlobalSelectCompanyComponent } from 'app/shared/component/global-company/global-company.component';
import { GlobalCompanyService } from 'app/shared/component/global-company/global-company.service';
import { SetFavouriteCompanyComponent } from 'app/shared/component/global-company/setfavouritecompany/setfavouritecompany.component';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { FuseAlertService } from '@fuse/components/alert';
import { MyProfileService } from 'app/main/myprofile/myprofile.service';
import { MyProfileModule } from 'app/main/myprofile/myprofile.module';

@Component({
    selector: 'classy-layout',
    templateUrl: './classy.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        
        FuseVerticalNavigationComponent,
        NotificationsComponent,
        UserComponent,
        MatIconModule,
        MatButtonModule,
        LanguagesComponent,
        FuseFullscreenComponent,
        SearchComponent,
        ShortcutsComponent,
        MessagesComponent,
        RouterOutlet,
        QuickChatComponent,    
        GlobalSelectCompanyComponent ,
        MatTooltipModule,MatDialogModule,MyProfileModule
    ],
    
})
export class ClassyLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: Navigation;
    user: User;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    isCompanyUser: boolean;
    confirmDialogRef: MatDialogRef<SetFavouriteCompanyComponent>;
    dialogRef: any;
    notificationService: NotificationService;
    message: string = '';
    private profilesub: Subscription;
    
    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _userService: UserService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private globalCompanyService:GlobalCompanyService,
        private _matDialog: MatDialog,
        private snb: MatSnackBar,
        public fuseAlertService: FuseAlertService,
        public _myProfileService: MyProfileService,
        
    ) { 
        this.notificationService = new NotificationService(snb);


        this._unsubscribeAll= new Subject()
        this.globalCompanyService.companyUser.subscribe(res => {
        this.isCompanyUser = res;
      });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    
    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to the message in the shared service
        this.profilesub = this._myProfileService.profilePic.subscribe((message) => {
            let userObj = JSON.parse(String(localStorage.getItem('currentUser')));
            //console.log(message);
            if (userObj) {
                this.user = userObj;
            }
        });

        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
            });

        let currentUserObj = JSON.parse(String(localStorage.getItem('currentUser')));
        if (currentUserObj) {
            this.user = currentUserObj;
        }

        // Subscribe to the user service
        // this._userService.user$
        //     .pipe(takeUntil(this._unsubscribeAll))
        //     .subscribe((user: User) => {
        //         
        //         this.user = user;
        //     });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        if(this.profilesub)
            this.profilesub.unsubscribe();

        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation =
            this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                name
            );

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    setFavouriteCompany() {
        this.dialogRef = this._matDialog.open(SetFavouriteCompanyComponent, {        
        });    
        this.dialogRef.afterClosed()
          .subscribe((response: FormGroup<any>[]) => {
            if (!response) {
            }
            const actionType: any = response[0];
            const formData: FormGroup = response[1];
            switch (actionType) {
              case "submit":
                var model = {
                  favouriteCompany: formData.controls.favouriteCompany.value
                }
                this.globalCompanyService.setFavouriteCompany(model).subscribe(res => {
                  if (res.status === 1) {
                    this.fuseAlertService.show("Favourite set successfully.", res.status);                   
                    this.globalCompanyService.setAssignedCompanyList();
                  }
                });
                break;
              /**
               * Delete
               */
              case "cancel":
                break;
            }
          });
    
      }
    
}
